import { Component, OnInit } from '@angular/core';
import { SearchService } from '../../search/search.service';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { ModalService } from '../../services/modal.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { SearchCriteria, Condition, Clause } from '../../search/models/search-filter-model';
import { DataTableConfig } from '../../search/models/data-table-config';
import { SearchEvent } from '../../search/models/search-event';
import { NEW_SEARCH_EVENT } from '../../search/search-constants';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { AlertService } from 'sce-core';

@Component({
  selector: 'lfwms-backend-status-popup',
  templateUrl: './wave-backend-status-popup.component.html',
  styleUrls: ['./wave-backend-status-popup.component.css']
})
export class WaveBackendStatusPopupComponent implements OnInit {
  public lookupSearchService: SearchService;
  constructor(public modalService: ModalService,
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService) { }

  ngOnInit() {
  }
   /*
   Allocation operation is implemented as loadByPage call
    that returns allocation action status as table data.
 */
  public initializeComponents(waveKey: string, tableId: string, moduleId) {
    // initialize the table and search context */
    this.initializeLookupSearchContext(tableId);
   
    this.callBackendStatusResData(waveKey, tableId, moduleId);
  }

  /* initialize the table and search context */
  public initializeLookupSearchContext(tableId: string) {

    const searchParams: SearchParams = new SearchParams();
    searchParams.tableId = tableId;
    searchParams.isFullFetch = true;
    //searchParams.columnCount = 15; ///???
    /* Data editor is needed  for tableheader filter to work.
     Filter might misbehave if datatype is not set properly in metdata from db. */
    searchParams.tableEditor = new DataTableEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    // Client side pagination enabled
    searchParams.paginateLocally = true;
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.enablePagination = true;
    tableConfig.enableFilter = true;
    searchParams.dataTableConfig = tableConfig;
    const searchStatus: SearchStatus = new SearchStatus();
    this.lookupSearchService = this.sharedServiceRegistry.createSearchService(searchParams,
      searchStatus);

  }
  /*
  Allocate API call and get response as loadBypage call.
    - clears the search criteria used for loadBypage request
      since it will conflict with logic for localpagination's paging, sort, filter etc.
  */
  private callBackendStatusResData(waveKey: string, tableId: string, moduleId) {
    this.lookupSearchService.clearSearchStatus();
    /* above call required to clear of unexpected behaviour
   -not sending backend calls from second time when multiple parellel requests are sent */
    this.lookupSearchService.setSearchCriteria(this._getNewSearchCriteria(waveKey, tableId, moduleId));
    // not reflecting?? this.lookupSearchService.pagedData.pageDefinition.pageSize = 1000;
    // this.lookupSearchService.performSearch();
    this.lookupSearchService.fetchSearchResults()
      .subscribe((data: any) => {
        this.lookupSearchService.searchStatus.hasResults = true;
        this.lookupSearchService.searchStatus.recordCount = this.lookupSearchService.pagedData.pageDefinition.recordCount;
        const event = new SearchEvent(NEW_SEARCH_EVENT);
        event.isSearchSuccess = true;
        this.lookupSearchService.publishEvent(event);
        // Clear search criteria to work with localPAgination
        this.lookupSearchService.setSearchCriteria(new SearchCriteria());
      });

  }

  private _getNewSearchCriteria(waveKey: string, tableId: string, moduleId) {
    const searchCriteria = new SearchCriteria();
    // Function snippet to reuse clause creation within this method
    const _createSearchClause = (columName: string, value: any) => {
      const clause = new Clause();
      clause.operation = '=';
      clause.column = columName;
      clause.value = value;
      clause.logicalOperation = 'AND';
      return clause;
    };
    const searchCondition = new Condition();
    searchCondition.isMandatory = true;
    searchCondition.operator = 'OR';
    searchCondition.clauses = [];
    searchCondition.clauses.push(_createSearchClause('documentKey1', waveKey));
    if(moduleId == 'wave'){
      searchCondition.clauses.push(_createSearchClause('moduleId', 'wave'));
    }else if(moduleId == 'transfer'){
      searchCondition.clauses.push(_createSearchClause('moduleId', 'transfer'));
    }else if(moduleId == 'receipt'){
      searchCondition.clauses.push(_createSearchClause('moduleId', 'Receipt'));
    }
    searchCriteria.conditions.push(searchCondition);
    return searchCriteria;
  }

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-backend-status-popup/wave-backend-status-popup.component.ts